// import getDateParts from '../../utils/dates/getDateParts';
// import formatDate from '../../utils/dates/formatDate';
import memoize from '../../utils/fp/memoize';

/**
 * @public
 * Split date parts in order to validate each one.
 *
 * @param  {String} date: an string representing a date (e.g MM/DD/YYYY or YYYY-MM-DD)
 * @return {Object} An object with a property for each moth, day, year and an additional
 * property with an array with all previous propeties.
 */
function splitDateParts(date) {
  // TODO: replace with a more powerful tool, e.g.:
  // getDateParts(date, format='dd/MM/yyy') -> {day,month,year,hour,minute,second}
  const parts = date.indexOf('/') > -1 ? date.split('/') : date.split('-');
  const year = parts[0].length === 4 ? +parts[0] : +parts[2];
  const month = parts[0].length === 4 ? +parts[1] : +parts[0];
  const day = parts[0].length === 4 ? +parts[2] : +parts[1];

  return {
    parts,
    month,
    day,
    year,
  };
}

export default memoize(splitDateParts);
